import React from 'react'
import { Table, Tag, Button } from 'antd'
import { CheckOutlined, CloseOutlined, FileTextOutlined } from '@ant-design/icons'
import moment from 'moment'

type Props = {
  tbtSignings: [],
  fetching: boolean,
  pagination: {},
  onChangeTable: () => void,
  onClickRow: () => void,
}

export default class extends React.PureComponent<Props> {

  render() {
    const {
      tbtSignings,
      fetching,
      pagination,
      onChangeTable,
      onClickRow,
    } = this.props

    const columns = [
      {
        title: 'Document Title',
        key: 'document_title',
        width: 300,
        sorter: true,
        fixed: 'left',
        render: (text, record) => (
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              <FileTextOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
              {(record.toolbox_talk_document && record.toolbox_talk_document.title) || 'Untitled Document'}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              Run Date: {record.toolbox_talk_run && record.toolbox_talk_run.run_at ? moment(record.toolbox_talk_run.run_at).format('DD/MM/YYYY') : 'N/A'}
            </div>
          </div>
        ),
      },
      {
        title: 'Status',
        key: 'status',
        width: 120,
        sorter: true,
        render: (text, record) => {
          if (record.signed) {
            return (
              <Tag color="green" icon={<CheckOutlined />}>
                SIGNED
              </Tag>
            )
          } else if (record.viewed) {
            return (
              <Tag color="orange">
                VIEWED
              </Tag>
            )
          } else {
            return (
              <Tag color="red">
                PENDING
              </Tag>
            )
          }
        },
      },
      {
        title: 'Created Date',
        key: 'created_at',
        width: 150,
        sorter: true,
        render: (text, record) => (
          <div>
            <div>{moment(record.created_at).format('DD/MM/YYYY')}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {moment(record.created_at).format('HH:mm')}
            </div>
          </div>
        ),
      },
      {
        title: 'Signed Date',
        key: 'signed_at',
        width: 150,
        sorter: true,
        render: (text, record) => {
          if (record.signed_at) {
            return (
              <div>
                <div>{moment(record.signed_at).format('DD/MM/YYYY')}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {moment(record.signed_at).format('HH:mm')}
                </div>
              </div>
            )
          }
          return <span style={{ color: '#ccc' }}>Not signed</span>
        },
      },
      {
        title: 'Action',
        key: 'action',
        width: 120,
        fixed: 'right',
        render: (text, record) => {
          if (record.signed) {
            return (
              <Button 
                size="small" 
                type="default"
                onClick={() => onClickRow(record.id)}
              >
                View
              </Button>
            )
          } else {
            return (
              <Button 
                size="small" 
                type="primary"
                onClick={() => onClickRow(record.id)}
              >
                Sign Now
              </Button>
            )
          }
        },
      },
    ]

    return (
      <Table
        columns={columns}
        dataSource={tbtSignings}
        loading={fetching}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} TBT documents`,
        }}
        onChange={onChangeTable}
        rowKey="id"
        scroll={{ x: 800 }}
        size="middle"
      />
    )
  }
}
